/** Chrome-style find-in-page bar (Ctrl/Cmd+F). Matching is done inside the proxied page by the injected script. */
import { useEffect, useRef, useState } from "react";
import { ChevronUp, ChevronDown, X } from "lucide-react";

export default function FindBar({ frameRef, result, onClose }) {
  const [q, setQ] = useState("");
  const inputRef = useRef(null);
  const send = (dir) => frameRef.current?.contentWindow?.postMessage({ __eliteFind: true, q, dir }, "*");

  useEffect(() => { inputRef.current?.focus(); inputRef.current?.select(); }, []);
  useEffect(() => { const t = setTimeout(() => send(q ? "next" : "clear"), 120); return () => clearTimeout(t); }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => frameRef.current?.contentWindow?.postMessage({ __eliteFind: true, dir: "clear" }, "*"), [frameRef]);

  const onKey = (e) => {
    if (e.key === "Enter") { e.preventDefault(); send(e.shiftKey ? "prev" : "next"); }
    if (e.key === "Escape") { e.preventDefault(); onClose(); }
  };
  const btn = "rounded p-1 text-gray-600 hover:bg-gray-200 disabled:opacity-30 dark:text-white/70 dark:hover:bg-white/15";
  return (
    <div className="absolute right-3 top-2 z-[60] flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-2 py-1 text-gray-900 shadow-xl dark:border-white/15 dark:bg-[#1f2126] dark:text-white" data-testid="browser-findbar">
      <input ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={onKey} placeholder="Find in page" data-testid="browser-find-input"
        className="w-44 bg-transparent px-1 text-xs outline-none placeholder:text-gray-400 dark:placeholder:text-white/40" />
      <span className={`min-w-[3rem] text-right font-mono text-[10px] ${q && result.count === 0 ? "text-red-500" : "text-gray-500 dark:text-white/50"}`} data-testid="browser-find-count">
        {q ? `${result.count ? result.index + 1 : 0}/${result.count}` : ""}
      </span>
      <span className="mx-1 h-4 w-px bg-gray-200 dark:bg-white/15" />
      <button type="button" onClick={() => send("prev")} disabled={!result.count} aria-label="Previous match" data-testid="browser-find-prev" className={btn}><ChevronUp className="h-3.5 w-3.5" /></button>
      <button type="button" onClick={() => send("next")} disabled={!result.count} aria-label="Next match" data-testid="browser-find-next" className={btn}><ChevronDown className="h-3.5 w-3.5" /></button>
      <button type="button" onClick={onClose} aria-label="Close find bar" data-testid="browser-find-close" className={btn}><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
